import { render } from "./RebateReciver.vue?vue&type=template&id=6b1c72b4"
import script from "./RebateReciver.vue?vue&type=script&lang=js"
export * from "./RebateReciver.vue?vue&type=script&lang=js"

import "./RebateReciver.vue?vue&type=style&index=0&id=6b1c72b4&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__